import { Popover } from "@/template/components";
import { CircleHelp } from "lucide-react";
import * as S from "../styles.ts";

const Help = ({ tip }: { tip: React.ReactNode }) => {
  if (!tip) return;
  return (
    <Popover
      tip={tip}
      delay={100}
    >
      <S.Help>
        <CircleHelp />
      </S.Help>
    </Popover>
  );
};

export default Help;
